module.exports = __webpack_public_path__ + "img/open.f6919672.svg";